import { Roles, TenantRoles } from '@/@types/auth.types';

const getUserRole = (roleId?: string) => {   
    switch (roleId) {
		case TenantRoles.Admin:
			return Roles.admin;
        case TenantRoles.Owner:
			return Roles.owner;
        default:
            return undefined;
	}
}

export const UserUtils = {
    getUserRole
}